import { useConsent } from '@/shared/consent';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Cookie } from 'lucide-react';

export function CookieConsentBanner(): React.ReactElement | null {
  const { showBanner, grantConsent, grantAll } = useConsent();

  if (!showBanner) return null;

  const handleRejectOptional = (): void => {
    grantConsent(['necessary']);
  };

  const handleAcceptAll = (): void => {
    grantAll();
  };

  return (
    <div className="fixed bottom-0 inset-x-0 p-4 z-50 print:hidden">
      <Card className="max-w-2xl mx-auto shadow-lg border-2">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-2 bg-primary/10 rounded-lg shrink-0">
              <Cookie className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1 space-y-3">
              <h3 className="font-semibold text-lg">Cookie Settings</h3>
              <p className="text-sm text-muted-foreground">
                We use cookies to improve your experience and analyze how you use our application.
                You can choose to accept all cookies or only the necessary ones.
              </p>
              <div className="flex flex-wrap gap-2 pt-2">
                <Button variant="outline" size="sm" onClick={handleRejectOptional}>
                  Necessary Only
                </Button>
                <Button size="sm" onClick={handleAcceptAll}>
                  Accept All
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
